import React, { memo, useCallback } from 'react';

import { Radio } from '@mui/material';
import PropTypes from 'prop-types';

import { radioStyles } from './RadioCellContent.styles';

const RadioCellContent = ({
  isChecked = false,
  isDisabled = false,
  onClick,
  itemId,
  dataTestId,
}) => {
  const handleClick = useCallback(
    e => {
      e.stopPropagation();

      onClick?.(itemId);
    },
    [onClick, itemId],
  );

  return (
    <Radio
      checked={isChecked}
      data-testid={dataTestId}
      disabled={isDisabled}
      sx={radioStyles}
      onClick={handleClick}
    />
  );
};

RadioCellContent.propTypes = {
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
};

export default memo(RadioCellContent);
